import { atom } from 'recoil';
import { PlatformFormation } from '../../types/formation';


export const formationsInUseState = atom<PlatformFormation[]>({
  key: 'formationsInUse',
  default: [],
});
